var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollect2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 615.542,
    height: 695,
    viewBox: "0 0 615.542 695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14577",
    "data-name": "Group 14577",
    transform: "translate(-227.458 -6747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14210",
    "data-name": "Group 14210",
    transform: "translate(0 63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14208",
    "data-name": "Group 14208",
    transform: "translate(227.458 6801.914)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3199",
    "data-name": "Ellipse 3199",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3201",
    "data-name": "Ellipse 3201",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3089",
    "data-name": "Ellipse 3089",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3091",
    "data-name": "Ellipse 3091",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3203",
    "data-name": "Ellipse 3203",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3205",
    "data-name": "Ellipse 3205",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3093",
    "data-name": "Ellipse 3093",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3095",
    "data-name": "Ellipse 3095",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3207",
    "data-name": "Ellipse 3207",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3209",
    "data-name": "Ellipse 3209",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3097",
    "data-name": "Ellipse 3097",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3099",
    "data-name": "Ellipse 3099",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3210",
    "data-name": "Ellipse 3210",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3211",
    "data-name": "Ellipse 3211",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3100",
    "data-name": "Ellipse 3100",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3101",
    "data-name": "Ellipse 3101",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3212",
    "data-name": "Ellipse 3212",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3213",
    "data-name": "Ellipse 3213",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3102",
    "data-name": "Ellipse 3102",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3103",
    "data-name": "Ellipse 3103",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3215",
    "data-name": "Ellipse 3215",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3217",
    "data-name": "Ellipse 3217",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3070",
    "data-name": "Ellipse 3070",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3106",
    "data-name": "Ellipse 3106",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3219",
    "data-name": "Ellipse 3219",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3221",
    "data-name": "Ellipse 3221",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3071",
    "data-name": "Ellipse 3071",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3109",
    "data-name": "Ellipse 3109",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3223",
    "data-name": "Ellipse 3223",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3225",
    "data-name": "Ellipse 3225",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3072",
    "data-name": "Ellipse 3072",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3073",
    "data-name": "Ellipse 3073",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3226",
    "data-name": "Ellipse 3226",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3227",
    "data-name": "Ellipse 3227",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3112",
    "data-name": "Ellipse 3112",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3074",
    "data-name": "Ellipse 3074",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3228",
    "data-name": "Ellipse 3228",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3229",
    "data-name": "Ellipse 3229",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3113",
    "data-name": "Ellipse 3113",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3075",
    "data-name": "Ellipse 3075",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3115",
    "data-name": "Ellipse 3115",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3117",
    "data-name": "Ellipse 3117",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3118",
    "data-name": "Ellipse 3118",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3076",
    "data-name": "Ellipse 3076",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3119",
    "data-name": "Ellipse 3119",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3120",
    "data-name": "Ellipse 3120",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3122",
    "data-name": "Ellipse 3122",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3124",
    "data-name": "Ellipse 3124",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3125",
    "data-name": "Ellipse 3125",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2800",
    "data-name": "Ellipse 2800",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3077",
    "data-name": "Ellipse 3077",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3126",
    "data-name": "Ellipse 3126",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3127",
    "data-name": "Ellipse 3127",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3129",
    "data-name": "Ellipse 3129",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3131",
    "data-name": "Ellipse 3131",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3132",
    "data-name": "Ellipse 3132",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2802",
    "data-name": "Ellipse 2802",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3078",
    "data-name": "Ellipse 3078",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3133",
    "data-name": "Ellipse 3133",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3079",
    "data-name": "Ellipse 3079",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3134",
    "data-name": "Ellipse 3134",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3135",
    "data-name": "Ellipse 3135",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136",
    "data-name": "Ellipse 3136",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2804",
    "data-name": "Ellipse 2804",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3080",
    "data-name": "Ellipse 3080",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137",
    "data-name": "Ellipse 3137",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3138",
    "data-name": "Ellipse 3138",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139",
    "data-name": "Ellipse 3139",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2806",
    "data-name": "Ellipse 2806",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3081",
    "data-name": "Ellipse 3081",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3141",
    "data-name": "Ellipse 3141",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3143",
    "data-name": "Ellipse 3143",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144",
    "data-name": "Ellipse 3144",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3082",
    "data-name": "Ellipse 3082",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3145",
    "data-name": "Ellipse 3145",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3146",
    "data-name": "Ellipse 3146",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3147",
    "data-name": "Ellipse 3147",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3148",
    "data-name": "Ellipse 3148",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3150",
    "data-name": "Ellipse 3150",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3151",
    "data-name": "Ellipse 3151",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2809",
    "data-name": "Ellipse 2809",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3083",
    "data-name": "Ellipse 3083",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3152",
    "data-name": "Ellipse 3152",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3153",
    "data-name": "Ellipse 3153",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3155",
    "data-name": "Ellipse 3155",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3157",
    "data-name": "Ellipse 3157",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3158",
    "data-name": "Ellipse 3158",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2811",
    "data-name": "Ellipse 2811",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3084",
    "data-name": "Ellipse 3084",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3159",
    "data-name": "Ellipse 3159",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3085",
    "data-name": "Ellipse 3085",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3160",
    "data-name": "Ellipse 3160",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3161",
    "data-name": "Ellipse 3161",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3162",
    "data-name": "Ellipse 3162",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2813",
    "data-name": "Ellipse 2813",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3086",
    "data-name": "Ellipse 3086",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3163",
    "data-name": "Ellipse 3163",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3164",
    "data-name": "Ellipse 3164",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3165",
    "data-name": "Ellipse 3165",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815",
    "data-name": "Ellipse 2815",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3087",
    "data-name": "Ellipse 3087",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3167",
    "data-name": "Ellipse 3167",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3169",
    "data-name": "Ellipse 3169",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3171",
    "data-name": "Ellipse 3171",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3173",
    "data-name": "Ellipse 3173",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3175",
    "data-name": "Ellipse 3175",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3177",
    "data-name": "Ellipse 3177",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3178",
    "data-name": "Ellipse 3178",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3179",
    "data-name": "Ellipse 3179",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3180",
    "data-name": "Ellipse 3180",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3181",
    "data-name": "Ellipse 3181",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3183",
    "data-name": "Ellipse 3183",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3185",
    "data-name": "Ellipse 3185",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3231",
    "data-name": "Ellipse 3231",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3233",
    "data-name": "Ellipse 3233",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3187",
    "data-name": "Ellipse 3187",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3189",
    "data-name": "Ellipse 3189",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3235",
    "data-name": "Ellipse 3235",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3237",
    "data-name": "Ellipse 3237",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3191",
    "data-name": "Ellipse 3191",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3193",
    "data-name": "Ellipse 3193",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3239",
    "data-name": "Ellipse 3239",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3241",
    "data-name": "Ellipse 3241",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3194",
    "data-name": "Ellipse 3194",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3195",
    "data-name": "Ellipse 3195",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3242",
    "data-name": "Ellipse 3242",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3243",
    "data-name": "Ellipse 3243",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3196",
    "data-name": "Ellipse 3196",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3197",
    "data-name": "Ellipse 3197",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3244",
    "data-name": "Ellipse 3244",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3245",
    "data-name": "Ellipse 3245",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14209",
    "data-name": "Group 14209",
    transform: "translate(725.086 7056.271) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957-2",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198-2",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958-2",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3199-2",
    "data-name": "Ellipse 3199",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959-2",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200-2",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960-2",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3201-2",
    "data-name": "Ellipse 3201",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833-2",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088-2",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834-2",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3089-2",
    "data-name": "Ellipse 3089",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835-2",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090-2",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836-2",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3091-2",
    "data-name": "Ellipse 3091",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961-2",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202-2",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962-2",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3203-2",
    "data-name": "Ellipse 3203",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963-2",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204-2",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964-2",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3205-2",
    "data-name": "Ellipse 3205",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837-2",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092-2",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838-2",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3093-2",
    "data-name": "Ellipse 3093",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839-2",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094-2",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840-2",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3095-2",
    "data-name": "Ellipse 3095",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965-2",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206-2",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966-2",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3207-2",
    "data-name": "Ellipse 3207",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967-2",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208-2",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968-2",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3209-2",
    "data-name": "Ellipse 3209",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841-2",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096-2",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842-2",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3097-2",
    "data-name": "Ellipse 3097",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843-2",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098-2",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844-2",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3099-2",
    "data-name": "Ellipse 3099",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969-2",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3210-2",
    "data-name": "Ellipse 3210",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970-2",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3211-2",
    "data-name": "Ellipse 3211",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845-2",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3100-2",
    "data-name": "Ellipse 3100",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846-2",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3101-2",
    "data-name": "Ellipse 3101",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971-2",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3212-2",
    "data-name": "Ellipse 3212",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972-2",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3213-2",
    "data-name": "Ellipse 3213",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847-2",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3102-2",
    "data-name": "Ellipse 3102",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848-2",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3103-2",
    "data-name": "Ellipse 3103",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973-2",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214-2",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974-2",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3215-2",
    "data-name": "Ellipse 3215",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975-2",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216-2",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976-2",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3217-2",
    "data-name": "Ellipse 3217",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849-2",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104-2",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850-2",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3070-2",
    "data-name": "Ellipse 3070",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851-2",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105-2",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852-2",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3106-2",
    "data-name": "Ellipse 3106",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977-2",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218-2",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978-2",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3219-2",
    "data-name": "Ellipse 3219",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979-2",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220-2",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980-2",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3221-2",
    "data-name": "Ellipse 3221",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853-2",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107-2",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854-2",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3071-2",
    "data-name": "Ellipse 3071",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855-2",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108-2",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856-2",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3109-2",
    "data-name": "Ellipse 3109",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981-2",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222-2",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982-2",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3223-2",
    "data-name": "Ellipse 3223",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983-2",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224-2",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984-2",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3225-2",
    "data-name": "Ellipse 3225",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857-2",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110-2",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858-2",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3072-2",
    "data-name": "Ellipse 3072",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859-2",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111-2",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860-2",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3073-2",
    "data-name": "Ellipse 3073",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985-2",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3226-2",
    "data-name": "Ellipse 3226",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986-2",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3227-2",
    "data-name": "Ellipse 3227",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861-2",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3112-2",
    "data-name": "Ellipse 3112",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862-2",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3074-2",
    "data-name": "Ellipse 3074",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987-2",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3228-2",
    "data-name": "Ellipse 3228",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988-2",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3229-2",
    "data-name": "Ellipse 3229",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863-2",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3113-2",
    "data-name": "Ellipse 3113",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864-2",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3075-2",
    "data-name": "Ellipse 3075",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925-2",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114-2",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926-2",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3115-2",
    "data-name": "Ellipse 3115",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927-2",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116-2",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928-2",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3117-2",
    "data-name": "Ellipse 3117",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865-2",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3118-2",
    "data-name": "Ellipse 3118",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798-2",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3076-2",
    "data-name": "Ellipse 3076",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866-2",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3119-2",
    "data-name": "Ellipse 3119",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799-2",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3120-2",
    "data-name": "Ellipse 3120",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929-2",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121-2",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930-2",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3122-2",
    "data-name": "Ellipse 3122",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931-2",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123-2",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932-2",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3124-2",
    "data-name": "Ellipse 3124",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867-2",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3125-2",
    "data-name": "Ellipse 3125",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2800-2",
    "data-name": "Ellipse 2800",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3077-2",
    "data-name": "Ellipse 3077",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868-2",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3126-2",
    "data-name": "Ellipse 3126",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801-2",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3127-2",
    "data-name": "Ellipse 3127",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933-2",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128-2",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934-2",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3129-2",
    "data-name": "Ellipse 3129",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935-2",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130-2",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936-2",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3131-2",
    "data-name": "Ellipse 3131",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869-2",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3132-2",
    "data-name": "Ellipse 3132",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2802-2",
    "data-name": "Ellipse 2802",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3078-2",
    "data-name": "Ellipse 3078",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870-2",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3133-2",
    "data-name": "Ellipse 3133",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803-2",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3079-2",
    "data-name": "Ellipse 3079",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937-2",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3134-2",
    "data-name": "Ellipse 3134",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938-2",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3135-2",
    "data-name": "Ellipse 3135",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871-2",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136-2",
    "data-name": "Ellipse 3136",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2804-2",
    "data-name": "Ellipse 2804",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3080-2",
    "data-name": "Ellipse 3080",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939-2",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137-2",
    "data-name": "Ellipse 3137",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940-2",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3138-2",
    "data-name": "Ellipse 3138",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805-2",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139-2",
    "data-name": "Ellipse 3139",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2806-2",
    "data-name": "Ellipse 2806",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3081-2",
    "data-name": "Ellipse 3081",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941-2",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140-2",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942-2",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943-2",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142-2",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944-2",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3143-2",
    "data-name": "Ellipse 3143",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872-2",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144-2",
    "data-name": "Ellipse 3144",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807-2",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3082-2",
    "data-name": "Ellipse 3082",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873-2",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3145-2",
    "data-name": "Ellipse 3145",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808-2",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3146-2",
    "data-name": "Ellipse 3146",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2945",
    "data-name": "Ellipse 2945",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3147-2",
    "data-name": "Ellipse 3147",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946-2",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3148-2",
    "data-name": "Ellipse 3148",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947-2",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149-2",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948-2",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3150-2",
    "data-name": "Ellipse 3150",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874-2",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3151-2",
    "data-name": "Ellipse 3151",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2809-2",
    "data-name": "Ellipse 2809",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3083-2",
    "data-name": "Ellipse 3083",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875-2",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3152-2",
    "data-name": "Ellipse 3152",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810-2",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3153-2",
    "data-name": "Ellipse 3153",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949-2",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154-2",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950-2",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3155-2",
    "data-name": "Ellipse 3155",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951-2",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156-2",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952-2",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3157-2",
    "data-name": "Ellipse 3157",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876-2",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3158-2",
    "data-name": "Ellipse 3158",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2811-2",
    "data-name": "Ellipse 2811",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3084-2",
    "data-name": "Ellipse 3084",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877-2",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3159-2",
    "data-name": "Ellipse 3159",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812-2",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3085-2",
    "data-name": "Ellipse 3085",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953-2",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3160-2",
    "data-name": "Ellipse 3160",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954-2",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3161-2",
    "data-name": "Ellipse 3161",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878-2",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3162-2",
    "data-name": "Ellipse 3162",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2813-2",
    "data-name": "Ellipse 2813",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3086-2",
    "data-name": "Ellipse 3086",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955-2",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3163-2",
    "data-name": "Ellipse 3163",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956-2",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3164-2",
    "data-name": "Ellipse 3164",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814-2",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3165-2",
    "data-name": "Ellipse 3165",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815-2",
    "data-name": "Ellipse 2815",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3087-2",
    "data-name": "Ellipse 3087",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879-2",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166-2",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880-2",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3167-2",
    "data-name": "Ellipse 3167",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881-2",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168-2",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882-2",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3169-2",
    "data-name": "Ellipse 3169",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885-2",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170-2",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886-2",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3171-2",
    "data-name": "Ellipse 3171",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887-2",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172-2",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888-2",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3173-2",
    "data-name": "Ellipse 3173",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891-2",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174-2",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892-2",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3175-2",
    "data-name": "Ellipse 3175",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893-2",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176-2",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894-2",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3177-2",
    "data-name": "Ellipse 3177",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897-2",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3178-2",
    "data-name": "Ellipse 3178",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898-2",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3179-2",
    "data-name": "Ellipse 3179",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900-2",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3180-2",
    "data-name": "Ellipse 3180",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901-2",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3181-2",
    "data-name": "Ellipse 3181",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902-2",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182-2",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903-2",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3183-2",
    "data-name": "Ellipse 3183",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904-2",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184-2",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905-2",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3185-2",
    "data-name": "Ellipse 3185",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989-2",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230-2",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990-2",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3231-2",
    "data-name": "Ellipse 3231",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(275.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991-2",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232-2",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992-2",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3233-2",
    "data-name": "Ellipse 3233",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908-2",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186-2",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909-2",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3187-2",
    "data-name": "Ellipse 3187",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910-2",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188-2",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911-2",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3189-2",
    "data-name": "Ellipse 3189",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993-2",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234-2",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994-2",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3235-2",
    "data-name": "Ellipse 3235",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(286.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995-2",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236-2",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996-2",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3237-2",
    "data-name": "Ellipse 3237",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(254.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914-2",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190-2",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915-2",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3191-2",
    "data-name": "Ellipse 3191",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916-2",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192-2",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917-2",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3193-2",
    "data-name": "Ellipse 3193",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997-2",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238-2",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998-2",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3239-2",
    "data-name": "Ellipse 3239",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(297.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999-2",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240-2",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000-2",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3241-2",
    "data-name": "Ellipse 3241",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(265.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920-2",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3194-2",
    "data-name": "Ellipse 3194",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921-2",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3195-2",
    "data-name": "Ellipse 3195",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001-2",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3242-2",
    "data-name": "Ellipse 3242",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002-2",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3243-2",
    "data-name": "Ellipse 3243",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(307.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923-2",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3196-2",
    "data-name": "Ellipse 3196",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924-2",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3197-2",
    "data-name": "Ellipse 3197",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003-2",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3244-2",
    "data-name": "Ellipse 3244",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004-2",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3245-2",
    "data-name": "Ellipse 3245",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(319.045 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14207",
    "data-name": "Group 14207",
    transform: "translate(-837 10782)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3889",
    "data-name": "Rectangle 3889",
    width: 533,
    height: 411,
    rx: 12,
    transform: "translate(1105 -4058)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3890",
    "data-name": "Rectangle 3890",
    width: 533,
    height: 536,
    rx: 12,
    transform: "translate(1105 -3979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Collect_money_in_local_currency",
    "data-name": "Collect money in local currency",
    transform: "translate(1376 -4009)",
    fill: "#fff",
    fontSize: 28,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -220.626,
    y: 0
  }, "Collect money in local currency")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14197",
    "data-name": "Group 14197",
    transform: "translate(402 -4185)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Account_holder_name_Agile_Capital_Private_Limited",
    "data-name": "Account holder name Agile Capital Private Limited",
    transform: "translate(733 300)",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account holder name"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Agile Capital Private Limited"))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy",
    "data-name": "Icon feather-copy",
    transform: "translate(892 291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.178)",
    fill: "none",
    stroke: "#c5dfd2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#c5dfd2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14198",
    "data-name": "Group 14198",
    transform: "translate(123 -4073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8520",
    "data-name": "Group 8520",
    transform: "translate(-495)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Account_number_8332464570",
    "data-name": "Account number  8332464570",
    transform: "translate(1507 300)",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account number "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "8332464570")))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy-2",
    "data-name": "Icon feather-copy",
    transform: "translate(1135.65 290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509-2",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.178)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510-2",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14199",
    "data-name": "Group 14199",
    transform: "translate(123 -4017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8520-2",
    "data-name": "Group 8520",
    transform: "translate(-495)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ACH_routing_number_026073150",
    "data-name": "ACH routing number 026073150",
    transform: "translate(1507 300)",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ACH routing number"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "026073150")))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy-3",
    "data-name": "Icon feather-copy",
    transform: "translate(1161.65 290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509-3",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.178)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510-3",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14200",
    "data-name": "Group 14200",
    transform: "translate(338.35 -4017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8520-3",
    "data-name": "Group 8520",
    transform: "translate(-495)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Fedwire_ABA_routing_number_026073008",
    "data-name": "Fedwire/ABA routing number 026073008",
    transform: "translate(1507 300)",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fedwire/ABA routing number"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "026073008"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3188",
    "data-name": "Rectangle 3188",
    width: 1,
    height: 36,
    transform: "translate(1493.65 290)",
    fill: "#d7dfe6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy-4",
    "data-name": "Icon feather-copy",
    transform: "translate(1219 290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509-4",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.178)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510-4",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14201",
    "data-name": "Group 14201",
    transform: "translate(123 -4028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8519",
    "data-name": "Group 8519",
    transform: "translate(-495)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Bank_name_Community_Federal_Savings_Bank",
    "data-name": "Bank name Community Federal Savings Bank",
    transform: "translate(1507 353)",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Bank name"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "Community Federal Savings Bank")))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy-5",
    "data-name": "Icon feather-copy",
    transform: "translate(1097.65 359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509-5",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.178)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510-5",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14202",
    "data-name": "Group 14202",
    transform: "translate(402 -4297)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Account_holder_address_26_Prinsep_Street_Singapore_188994",
    "data-name": "Account holder address 26 Prinsep Street, Singapore, 188994",
    transform: "translate(733 453)",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Account holder address"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "26 Prinsep Street, Singapore, 188994"))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy-6",
    "data-name": "Icon feather-copy",
    transform: "translate(906.325 459.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509-6",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.177)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510-6",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14203",
    "data-name": "Group 14203",
    transform: "translate(1135 -3616)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Bank_address_8916_Jamaica_Ave_Woodhaven_NY_11421_USA",
    "data-name": "Bank address 8916 Jamaica Ave, Woodhaven, NY 11421, USA",
    fill: "#5d6578",
    fontSize: 14,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Bank address"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "8916 Jamaica Ave, Woodhaven, NY 11421, USA"))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy-7",
    "data-name": "Icon feather-copy",
    transform: "translate(99.494 6.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509-7",
    "data-name": "Path 1509",
    d: "M14.735,13.5h5.557a1.235,1.235,0,0,1,1.235,1.235v5.557a1.235,1.235,0,0,1-1.235,1.235H14.735A1.235,1.235,0,0,1,13.5,20.292V14.735A1.235,1.235,0,0,1,14.735,13.5Z",
    transform: "translate(-9.178 -9.178)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510-7",
    "data-name": "Path 1510",
    d: "M4.852,11.027H4.235A1.235,1.235,0,0,1,3,9.792V4.235A1.235,1.235,0,0,1,4.235,3H9.792a1.235,1.235,0,0,1,1.235,1.235v.617",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#9fbeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14204",
    "data-name": "Group 14204",
    transform: "translate(402 -4232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(733 275.706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 26.623,
    height: 16.468,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 26.623,
    height: 2.122,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 4.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 8.149)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 14.345)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 12.223)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 13.724,
    height: 9.853,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.394 1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.3,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.52,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-79.342 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.158,207.077l-.221-.68-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-26.001 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M26.937,160.624l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.3,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M26.937,114.85l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.661,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.882,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-132.682 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.245,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-186.024 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.024,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.661,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.024,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -114.85)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "USD",
    transform: "translate(769 293)",
    fill: "#111",
    fontSize: 22,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD"))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M0,8.053V.423q0-.846,0,0C0,.988,0,1.9,0,2.464v8.645c0,.546,0,.558,0,.042V2.47c0-.282,0-.654,0-1.021S0,.711,0,.429q0-.846,0,0Z",
    transform: "translate(1449 -3873) rotate(-90)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14206",
    "data-name": "Group 14206",
    transform: "translate(419.251 -4232)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Download",
    transform: "translate(1122 291)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download")), /*#__PURE__*/React.createElement("text", {
    id: "Copy_instructions",
    "data-name": "Copy instructions",
    transform: "translate(942 291)",
    fill: "#5d6578",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Copy instructions")), /*#__PURE__*/React.createElement("g", {
    id: "direct-download",
    transform: "translate(1082 268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M23.25,15.75,18,21.25l-5.25-5.5h3.5V9.25a.5.5,0,0,1,.5-.5h2.5a.5.5,0,0,1,.5.5v6.5Z",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M18,22a.749.749,0,0,1-.542-.232l-5.25-5.5A.75.75,0,0,1,12.75,15H15.5V9.25A1.252,1.252,0,0,1,16.75,8h2.5A1.252,1.252,0,0,1,20.5,9.25V15h2.75a.75.75,0,0,1,.542,1.268l-5.25,5.5A.749.749,0,0,1,18,22Zm-3.5-5.5L18,20.164,21.5,16.5H19.75a.75.75,0,0,1-.75-.75V9.5H17v6.25a.75.75,0,0,1-.75.75Z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M28.25,28H7.75A1.752,1.752,0,0,1,6,26.25v-.5A1.752,1.752,0,0,1,7.75,24h20.5A1.752,1.752,0,0,1,30,25.75v.5A1.752,1.752,0,0,1,28.25,28ZM7.75,25.5a.25.25,0,0,0-.25.25v.5a.25.25,0,0,0,.25.25h20.5a.25.25,0,0,0,.25-.25v-.5a.25.25,0,0,0-.25-.25Z",
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(906.749 270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(11.77 6.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8654",
    "data-name": "Group 8654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M25.609,8.409v11.2a1.659,1.659,0,0,1-1.659,1.659h-9.54a1.659,1.659,0,0,1-1.659-1.659V8.409A1.659,1.659,0,0,1,14.409,6.75h9.54A1.659,1.659,0,0,1,25.609,8.409Z",
    transform: "translate(-12.75 -6.75)",
    fill: "#61ce65"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "regular",
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8657",
    "data-name": "Group 8657",
    transform: "translate(4.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M23.822,21.762h-9.54A2.283,2.283,0,0,1,12,19.481V8.281A2.283,2.283,0,0,1,14.281,6h9.54A2.283,2.283,0,0,1,26.1,8.281v11.2A2.283,2.283,0,0,1,23.822,21.762ZM14.281,7.244a1.038,1.038,0,0,0-1.037,1.037v11.2a1.038,1.038,0,0,0,1.037,1.037h9.54a1.038,1.038,0,0,0,1.037-1.037V8.281a1.038,1.038,0,0,0-1.037-1.037Z",
    transform: "translate(-12 -6)",
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8658",
    "data-name": "Group 8658",
    transform: "translate(0 2.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M19.236,26.336H9.281A2.283,2.283,0,0,1,7,24.055V10.781A2.283,2.283,0,0,1,9.281,8.5H9.7V9.744H9.281a1.038,1.038,0,0,0-1.037,1.037V24.055a1.038,1.038,0,0,0,1.037,1.037h9.955a1.038,1.038,0,0,0,1.037-1.037V23.64h1.244v.415A2.283,2.283,0,0,1,19.236,26.336Z",
    transform: "translate(-7 -8.5)",
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8659",
    "data-name": "Group 8659",
    transform: "translate(8.089 5.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M16.75,13h6.222v1.244H16.75Z",
    transform: "translate(-16.75 -13)",
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8660",
    "data-name": "Group 8660",
    transform: "translate(8.089 8.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M16.75,16h6.222v1.244H16.75Z",
    transform: "translate(-16.75 -16)",
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8661",
    "data-name": "Group 8661",
    transform: "translate(8.089 10.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M16.75,19h6.222v1.244H16.75Z",
    transform: "translate(-16.75 -19)",
    fill: "#030303"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2517",
    "data-name": "Rectangle 2517",
    width: 1,
    height: 20,
    transform: "translate(1072 276)",
    fill: "#d7dfe6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3108",
    "data-name": "Rectangle 3108",
    width: 473,
    height: 1,
    transform: "translate(1135 -3563)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3891",
    "data-name": "Rectangle 3891",
    width: 473,
    height: 1,
    transform: "translate(1135 -3916)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8517",
    "data-name": "Group 8517",
    transform: "translate(1135 -3553)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Share_details",
    "data-name": "Share details",
    transform: "translate(53 18)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -52.792,
    y: 0
  }, "Share details"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7679",
    "data-name": "Group 7679",
    transform: "translate(1135 -3517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2564",
    "data-name": "Rectangle 2564",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221,
    height: 44,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 220,
    height: 43,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Enter_email_address",
    "data-name": "Enter email address",
    transform: "translate(49.079 27)",
    fill: "#848b9c",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Enter email address")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7681",
    "data-name": "Group 7681",
    transform: "translate(22 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M-13669.1,818.231l1.523-2.394,17.264.29,1.6,1.6-1.6,1.6-8.487,6.383Z",
    transform: "translate(13669.103 -815.837)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(0.103 0.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M5.039,6H21.353a2.116,2.116,0,0,1,2.039,2.173v13.04a2.116,2.116,0,0,1-2.039,2.173H5.039A2.116,2.116,0,0,1,3,21.214V8.173A2.116,2.116,0,0,1,5.039,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "#176b41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M23.393,9,13.2,16.607,3,9",
    transform: "translate(-3 -6.827)",
    fill: "none",
    stroke: "#176b41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8144",
    "data-name": "Group 8144",
    transform: "translate(1376 -3517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2564-2",
    "data-name": "Rectangle 2564",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 44,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 193,
    height: 43,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Enter_number",
    "data-name": "Enter number",
    transform: "translate(42.283 27)",
    fill: "#848b9c",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Enter number")), /*#__PURE__*/React.createElement("g", {
    id: "whatsapp_2_",
    "data-name": "whatsapp (2)",
    transform: "translate(16 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M10.014,0h-.005a10.005,10.005,0,0,0-8.1,15.88L.658,19.6l3.848-1.23A10.01,10.01,0,1,0,10.014,0Z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M118.909,126.647a2.825,2.825,0,0,1-1.965,1.413c-.523.111-1.206.2-3.507-.753a12.542,12.542,0,0,1-4.985-4.4,5.718,5.718,0,0,1-1.189-3.02,3.2,3.2,0,0,1,1.024-2.437,1.455,1.455,0,0,1,1.024-.359c.124,0,.235.006.335.011.294.013.442.03.636.494.242.582.83,2.019.9,2.166a.6.6,0,0,1,.043.542,1.73,1.73,0,0,1-.324.459c-.148.17-.288.3-.436.483-.135.159-.288.329-.118.623a8.886,8.886,0,0,0,1.624,2.019,7.36,7.36,0,0,0,2.348,1.448.633.633,0,0,0,.706-.111,12.114,12.114,0,0,0,.782-1.036.559.559,0,0,1,.718-.218c.27.094,1.7.8,1.995.947s.488.218.559.342A2.493,2.493,0,0,1,118.909,126.647Z",
    transform: "translate(-103.069 -112.509)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8557",
    "data-name": "Group 8557",
    transform: "translate(206 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-2",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M6.389,5.1,11.22.268a.909.909,0,0,1,1.289,0,.92.92,0,0,1,0,1.293L7.036,7.038a.911.911,0,0,1-1.259.027L.266,1.565A.913.913,0,1,1,1.556.272Z",
    transform: "translate(11.599 21.387) rotate(-90)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect2);
export default __webpack_public_path__ + "static/media/collect_2.3c8598451e2beae652fb5925d042ba54.svg";
export { ForwardRef as ReactComponent };